import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { api, formatApiError } from "../lib/api";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/reset-password", { token, password }); setDone(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="App bg-[#F4F7FA] min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-20">
        {done ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center shadow-sm" data-testid="reset-success">
            <CheckCircle2 className="w-12 h-12 text-mint mx-auto" />
            <h1 className="mt-3 font-heading font-bold text-2xl text-navy">Password updated</h1>
            <p className="mt-2 text-slate-600">You can now log in with your new password.</p>
            <button data-testid="reset-to-login" onClick={() => navigate("/login")} className="mt-5 bg-mint text-white font-semibold px-6 py-3 rounded-xl hover:bg-mint-dark transition-colors">Go to log in</button>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-2"><KeyRound className="w-6 h-6 text-mint-dark" /><h1 className="text-2xl font-bold font-heading text-navy">Choose a new password</h1></div>
            {!token ? (
              <p className="mt-4 text-slate-600">This reset link is invalid. <Link to="/forgot-password" className="text-mint-dark font-semibold">Request a new one</Link>.</p>
            ) : (
              <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-slate-200 p-6 shadow-sm flex flex-col gap-4" data-testid="reset-form">
                <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 6 chars)"
                  className="w-full border border-slate-300 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-mint" />
                {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
                <button data-testid="reset-submit" disabled={loading} className="bg-mint text-white font-semibold py-3 rounded-xl hover:bg-mint-dark transition-colors disabled:opacity-60">
                  {loading ? "Updating…" : "Update password"}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
